import { useGlobalKeyHandler } from './useGlobalKeyHandler';

/** @param callback to run when the user presses Escape */
export const useEscapeKeyHandler = (callback?: () => void) =>
  useGlobalKeyHandler('Escape', callback);
